$(document).ready(function(){
$('.slick-nav').on('click touch', function(e) {
    e.preventDefault();
    var arrow = $(this);
    if(!arrow.hasClass('animate')) {
        arrow.addClass('animate');
        setTimeout(() => {
            arrow.removeClass('animate');
        }, 1600);
    }
});
  $('.banner-slider-items').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var next = $(".slick-current").attr("class");
    $("button.click-play").trigger("click");
});

})

